import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-aeroplanta-index',
  templateUrl: './aeroplanta-index.component.html',
  styleUrls: ['./aeroplanta-index.component.css']
})
export class AeroplantaIndexComponent {

  constructor(private authService: AuthService) { }

  TipoUsuario = TipoUsuario;

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
